import { useState, useCallback } from 'react';
import { ErrorHandler, ApiError } from '../errors';

interface ErrorState {
  message: string;
  code: string;
  details?: Record<string, any>;
}

export const useErrorHandler = () => {
  const [error, setError] = useState<ErrorState | null>(null);

  const handleError = useCallback((error: unknown) => {
    const apiError = ErrorHandler.handle(error);
    setError({
      message: apiError.error.message,
      code: apiError.error.code,
      details: apiError.error.details
    });
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    error,
    handleError,
    clearError
  };
}; 